import SDK from '../../sdk/sdk';
import sdkMiddleware from './sdkMiddleware';

export function createMiddleware() {
  const sdk = new SDK();

  return [sdkMiddleware(sdk)];
}
